<template>
  <div :class="['tw:w-full', customClass]">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { provide } from 'vue'
import { TabsContextKey } from './useTabsContext'

const props = withDefaults(
  defineProps<{
    modelValue: string
    customClass?: string
  }>(),
  {
    customClass: ''
  }
)

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

provide(TabsContextKey, {
  value: computed(() => props.modelValue),
  onValueChange: (value: string) => emit('update:modelValue', value)
})
</script>
